var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWaiterPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#EDF9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 19.5H11.875C11.6562 19.5 11.5 19.3438 11.5 19.125V10.875C11.5 10.6875 11.6562 10.5 11.875 10.5H20.125C20.3125 10.5 20.5 10.6875 20.5 10.875V19.125C20.5 19.3438 20.3125 19.5 20.125 19.5ZM23 9.5V22.5C23 23.3438 22.3125 24 21.5 24H10.5C9.65625 24 9 23.3438 9 22.5V9.5C9 8.6875 9.65625 8 10.5 8H21.5C22.3125 8 23 8.6875 23 9.5ZM21.5 22.3125V9.6875C21.5 9.59375 21.4062 9.5 21.3125 9.5H10.6875C10.5625 9.5 10.5 9.59375 10.5 9.6875V22.3125C10.5 22.4375 10.5625 22.5 10.6875 22.5H21.3125C21.4062 22.5 21.5 22.4375 21.5 22.3125ZM18 21.125C18 21.3438 17.8125 21.5 17.625 21.5H14.375C14.1562 21.5 14 21.3438 14 21.125V20.875C14 20.6875 14.1562 20.5 14.375 20.5H17.625C17.8125 20.5 18 20.6875 18 20.875V21.125Z",
    fill: "#0085E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWaiterPrimary);
export default __webpack_public_path__ + "static/media/mobile-waiter-primary.d18f1377.svg";
export { ForwardRef as ReactComponent };